import { SYSBaseElement } from "../sysbaseelement"
import { DirectiveResult, TemplateResult, html } from "../../"
import { isMobile } from "../../global/globals"

export type SnackType =
  | "Information"
  | "Warning"
  | "Success"
  | "Error"
  | "BusyIndicator"
  | "none"

export let SnackId = { id: 0 }

const nrOfSnacks = 3

export type SnackState = {
  text: string | DirectiveResult | TemplateResult
  type: SnackType
  durationMs?: number
  id?: number
  status?: "queued" | "running"
  key?: string
  cancelable?: boolean
  onCancel?: () => void
}

export type SnackAddState = {
  text: string | DirectiveResult | TemplateResult
  type: SnackType
  durationMs?: number
  key?: string
  cancelable?: boolean
  onCancel?: () => void
}

export const RemoveSnack = (div) => {
  if (div) {
    div.classList.remove("fadeInSnack")
    div.classList.add("fadeOutSnack")
  }
}

export class SYSSnack extends SYSBaseElement {
  async init() {
    this.addEventListener("animationend", this.handleAnimationEnd)
    await super.init()
  }

  handleAnimationEnd = (e) => {
    let id = e.target.id

    if (e.animationName === "fadeInSnack") {
      e.target.classList.remove("fadeInSnack")
    } else if (e.animationName === "fadeOutSnack") {
      let parent = e.target.parentElement

      parent.removeChild(e.target)
      this.actions.ovl.internal._ClearSnack({ id, el: parent })
    }
  }

  async getUI() {
    // this render just defines the slots...
    // all other handling is in the ...Snack - Actions
    let res = []
    for (let z = 0; z < nrOfSnacks; z++) {
      res.push(html` <div></div> `)
    }

    let width = ""
    return html`
      <div id="ovlsnack" class="ovl-snacks">${res.map((m) => m)}</div>
    `
  }
}
